import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Reset CSS mínimo
const style = document.createElement('style');

style.textContent = `
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background: #F2F3F4;
    color: #2C3E50;
  }

  button:focus,
  input:focus,
  select:focus {
    outline: 2px solid #2E86C1;
    outline-offset: 2px;
  }
`;

document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);